export const styles = {
  fileField: {
    width: 'full',
  },
  label: {
    textAlign: 'left',
    width: 'full',
    fontSize: 'md',
    fontWeight: 'medium',
  },
  alert: {
    display: 'flex',
    variant: 'subtle',
    borderRadius: 'lg',
    padding: 'md',
    flexWrap: 'wrap',
    status: 'info',
  },
  alertIcon: {
    boxSize: '5',
    marginRight: '2',
  },
  alertTitle: {
    fontSize: 'sm',
  },
  alertDescription: {
    fontSize: 'sm',
    marginLeft: 'auto',
  },
  iconButton: {
    size: 'sm',
    variant: 'ghost',
  },
  passwordField: {
    size: 'sm',
    flexBasis: '100%',
    labelProps: {
      marginBottom: '0.5',
    },
  },
  submitButton: {
    size: 'sm',
    paddingX: '5',
    variant: 'link',
    animationType: 'none',
  },
};
